<template>
  <div class="home_H">

    <el-container>
      <el-header style="height: 100px">

        <Head></Head>
      </el-header>
      <el-main class="main_body">
        <div class="main_body_newdiv">
          <div class="H_div">
            <div class="hero-content">
              <div class="H_div_A">全球优质IP代理服务</div>
              <div class="H_div_B">安全稳定的海外网络访问解决方案</div>
              <div class="H_div_C">
                覆盖全球国家地区 · 海量IP资源池 · 99.9%可用率 · 7*24小时技术支持
              </div>
              <div class="features-grid">
                <div class="feature-item">
                  <i class="el-icon-connection"></i>
                  <span>高匿名性</span>
                </div>
                <div class="feature-item">
                  <i class="el-icon-data-line"></i>
                  <span>高稳定性</span>
                </div>
                <div class="feature-item">
                  <i class="el-icon-refresh"></i>
                  <span>IP自动轮换</span>
                </div>
                <div class="feature-item">
                  <i class="el-icon-monitor"></i>
                  <span>全平台兼容</span>
                </div>
              </div>
              <div class="butts_main">
                <el-button @click="touserlog" type="primary" class="butt_A" round>立即体验
                </el-button>
                <el-button type="primary" class="butt_B" icon="el-icon-service" round @click="openWeChatChat">咨询方案
                </el-button>
              </div>
            </div>
            <div class="hero-image">
              <img src="../../assets/map.svg" alt="全球IP分布图" class="world-map" />
              <div class="connection-points">
                <div class="point" v-for="i in 6" :key="i"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="zhu_">注：所有类型IP仅支持在境外网络环境下使用</div>
        </div>
        <!--        <div class="div_8">-->
        <!--          <div class="div_8_div">-->
        <!--            <div class="div_8_top_text">众多企业及团队信赖</div>-->
        <!--            <div class="div_8_bot_div">-->
        <!--              <div>-->
        <!--                <img src="../../assets/l1.svg" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l2.svg" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l3.svg" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l4.svg" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l5.png" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l6.svg" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l7.svg" alt=""/>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <img src="../../assets/l8.png" alt=""/>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="div_9">
          <div class="div_9_div">
            <div class="div_9_top_text">安全可靠的代理服务</div>
            <div class="div_9_bot_div">
              <div v-for="item in Hgdat" :key="item.id">
                <div>
                  <img :src="item.img" alt="" />
                </div>
                <div class="div_9_bot_div_H1">{{ item.Hname }}</div>
                <div class="div_9_bot_div_H2">
                  {{ item.Htext }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="div_9">
          <div class="div_10_div">
            <div class="div_10_top_text">高性能、稳定的代理产品</div>
            <el-carousel trigger="click" height="550px" :interval="6000">
              <el-carousel-item v-for="item in dlcpdata" :key="item.id">
                <div class="lp_top_text">{{ item.topname }}</div>
                <div class="carousel_img">
                  <div>
                    <img :src="item.img" alt="" />
                  </div>
                  <div class="carousel_img_div">
                    <div class="carousel_img_Htop">{{ item.texts }}</div>
                    <div class="carousel_img_Htop_lis">
                      <div v-for="item in item.litext" :key="item" class="carousel_img_Htop_li">
                        <span style="
                            display: inline-block;
                            background-color: #409eff;
                            width: 7px;
                            height: 7px;
                            border-radius: 50%;
                            margin-right: 20px;
                          "></span>{{ item }}
                      </div>
                    </div>
                    <div>
                      <el-button @click="touserlog" class="bust_lo" type="primary" round>免费测试
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

      </el-main>

      <Footer></Footer>
    </el-container>

    <Xuanfuret></Xuanfuret>

    <div class="gg_left_top" @click="totop" v-if="topshow">
      <div>
        <div>
          <i class="el-icon-upload2 gg_left_top_i"></i>
          <div>置顶</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";

export default {
  name: "HomePage",
  components: {Head, Footer, Xuanfuret},
  metaInfo() {
    return {
      title: "奇迹ip - 全球优质IP代理服务",
      meta: [
        {
          name: "description",
          content: "提供安全稳定的海外网络访问解决方案，覆盖200+国家地区，千万级IP资源池，99.9%可用率，7*24小时技术支持。",
        },
        {
          name: "keywords",
          content: "IP代理,海外代理,代理服务,网络访问,高匿代理,稳定代理,IP池",
        },
        {
          property: "release_date",
          content: new Date().toISOString(),
        },
      ],
    };
  },


  data() {
    return {
      pageName: '奇迹ip',

      ggshow: false,
      topshow: false,
      showdivname: "",
      dlcpdata: [
        {
          id: 7,
          topname: "静态住宅代理",
          img: "http://apiupss.ppfly.top/images/intro_li4.svg",
          texts: "长效静态IP",
          litext: [
            "无限流量，不限并发",
            "99.9%在线稳定运行",
          ],
        },
      ],
      Hgdat: [
        {
          id: 4,
          Hname: "纯净资源",
          Htext:
              "与全球各大运营商合作，经过技术层算法筛选的纯净IP，可用率高达99.9%",
          img: "http://apiupss.ppfly.top/images/91.svg",
        },
        {
          id: 3,
          Hname: "无限并发",
          Htext:
              "不限并发请求次数，强大的服务器可承载亿级并发请求，时刻保持负载均衡",
          img: "http://apiupss.ppfly.top/images/92.svg",
        },
        {
          id: 2,
          Hname: "定制化服务",
          Htext:
              "深入分析用户业务场景，根据需求定制资源和功能，1V1量身定制服务方案",
          img: "http://apiupss.ppfly.top/images/93.svg",
        },
        {
          id: 1,
          Hname: "安全合规",
          Htext:
              "通过ISO9001&ISO27001信息安全认证标准，合规可信，满足行业高标准",
          img: "http://apiupss.ppfly.top/images/94.svg",
        },
      ],

    };
  },
  mounted() {
    // 组件挂载后添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);
    // 在组件挂载后，1秒后显示广告
    setTimeout(() => {
      this.ggshow = true;
    }, 1000);
  },
  beforeDestroy() {
    // 组件销毁前移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    openWeChatChat() {
    },
    touserlog() {
      this.$router.push({path: "userlogin"});
    },
    handleScroll() {
      // 检查滚动位置，决定是否显示组件
      this.topshow = window.scrollY > 200; // 当滚动超过200px时显示
    },

    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({top: 0, behavior: "smooth"});
    },
  },
};
</script>

<style scoped>
.home_H {
  /* position: relative; */
}

.log_img {
  width: 400px;
}

.show_div_img_main {
  position: fixed;
  z-index: 101;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0; /* 初始透明度 */
  transition: opacity 0.5s ease; /* 过渡效果 */
}

.fade-in {
  opacity: 1; /* 显示时的透明度 */
}

.show_div_img_main > div {
  display: flex;
  justify-content: center;
  transition: opacity 1s ease; /* 过渡效果 */
}

.show_div_img_main img {
  position: absolute;
  top: 260px;
  width: 400px;
  margin: 0 auto;
}

.guanbi_div {
  font-size: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #edf3fc;
  margin: 0 auto;
  margin-top: 690px;
}

.el-icon-circle-close {
  font-size: 30px;
  color: #edf3fc;
}

.gg_left_img {
  position: fixed;
  bottom: 30px;
  left: 24px;
  z-index: 99;
  display: block;
}

.gg_left_top {
  position: fixed;
  bottom: 120px;
  right: 24px;
  z-index: 99;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #edf3fc;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.5);
}

.gg_left_top > div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.gg_left_top_i {
  font-size: 20px;
}

.gg_left_top > div > div {
  color: #a6bad3;
  font-size: 13px;
}

.el-icon-arrow-down,
.el-icon-user {
  font-weight: 600;
}

.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
  margin: 0 auto;
}

.el-header {
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}

.top_index {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.letlogs {
  width: 17%;
  display: flex;
  justify-content: center;
  font-size: 40px;
  font-weight: 700;
}

.log {
  width: 50px;
  height: 50px;
  background-image: url("../../assets/log.png");
  background-size: cover;
}

.imgstop {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/tops.png");
  background-size: cover;
}

.imgstop > div div {
  color: #f15a24;
}

.imgstop_text {
  display: flex;
  justify-self: center;
  font-size: 25px;
  font-weight: 550;
  background-color: #edf3fc;
  width: 500px;
  margin: 0 auto;
}

.showdiv {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #edf3fc;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
  rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.title {
  padding: 0 15px 0 15px;
  display: inline-block;
  position: relative;
}

.showdiv_for {
  width: 100%;
  display: flex;
  justify-content: space-around;
  font-family: SourceHanSansCN-Regula;
}

.for_div_for {
  width: 300px;
  background-color: #409eff;
}

.showdivlist_lable {
  text-align: left;
  padding-left: 10px;
  font-size: 15px;
}

.spans {
  display: block;
  float: left;
  padding: 10px;
  font-size: 15px;
  line-height: 20px;
}

.spans_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  padding-left: 10px;
}

.span_text {
  font-size: 13px;
  margin-top: 5px;
  white-space: nowrap;
}

.title::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 3px;
  bottom: 0;
  left: 0;
  background-color: #409eff;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.title:hover {
  color: #409eff;
}

.title:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.main_B6_div_imgs_divAB {
  width: 190px;
  height: 130px;
  text-align: center;
}

.main_body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  scrollbar-width: none;
  padding: 0;
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
}

.main_body_newdiv {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  .H_div {
    flex-direction: column;
    padding: 40px 0;
  }

  .hero-content {
    max-width: 100%;
    text-align: center;
  }

  .H_div_A, .H_div_B, .H_div_C {
    text-align: center;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    max-width: 600px;
    margin: 30px auto;
  }

  .hero-image {
    max-width: 80%;
    margin: 40px auto 0;
  }

  .butts_main {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .H_div_A {
    font-size: 40px;
  }

  .H_div_B {
    font-size: 28px;
  }

  .H_div_C {
    font-size: 16px;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .butts_main {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .butt_A, .butt_B {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .H_div_A {
    font-size: 32px;
  }

  .H_div_B {
    font-size: 24px;
  }

  .H_div_C {
    font-size: 14px;
  }

  .feature-item {
    padding: 12px;
  }

  .feature-item i {
    font-size: 20px;
  }

  .feature-item span {
    font-size: 14px;
  }
}

.H_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  margin-top: 40px;
  padding: 60px 0;
  max-width: 1200px;
}

.hero-content {
  flex: 1;
  max-width: 600px;
}

.H_div_A {
  font-size: 56px;
  font-weight: 700;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  background: linear-gradient(90deg, #220d47, #6327d3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 20px;
}

.H_div_B {
  text-align: left;
  font-size: 36px;
  font-weight: 600;
  font-family: SourceHanSansCN-Medium;
  color: #220d47;
  margin-bottom: 20px;
}

.H_div_C {
  font-size: 18px;
  color: #666;
  text-align: left;
  width: 100%;
  margin: 25px 0;
  line-height: 1.6;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 30px 0;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background: rgba(99, 39, 211, 0.05);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
  background: rgba(99, 39, 211, 0.1);
}

.feature-item i {
  font-size: 24px;
  color: #6327d3;
}

.feature-item span {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.hero-image {
  flex: 1;
  position: relative;
  max-width: 500px;
  margin-left: 40px;
}

.world-map {
  width: 100%;
  height: auto;
  opacity: 0.8;
}

.connection-points {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.point {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #6327d3;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.point:nth-child(1) { top: 30%; left: 20%; animation-delay: 0s; }
.point:nth-child(2) { top: 50%; left: 40%; animation-delay: 0.4s; }
.point:nth-child(3) { top: 20%; left: 60%; animation-delay: 0.8s; }
.point:nth-child(4) { top: 60%; left: 70%; animation-delay: 1.2s; }
.point:nth-child(5) { top: 40%; left: 80%; animation-delay: 1.6s; }
.point:nth-child(6) { top: 70%; left: 30%; animation-delay: 2s; }

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}

.H_div_D {
  font-size: 14px;
  display: flex;
  justify-content: center;
  /* background-color: #edf3fc; */
}

.div_li {
  padding: 0;
  display: flex;
  align-items: center;
  width: 190px;
  margin-top: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  color: #252b42;
  line-height: 16px;
  margin-left: 6px;
}

.butts_main {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 49px;
  color: #edf3fc;
  column-gap: 14px;
}

.zhu_ {
  display: block;
  font-size: 14px;
  color: #988f91;
  text-align: center;
  margin-top: 44px;
  padding: 20px;
}

.butts_main {
  display: flex;
  gap: 20px;
  margin-top: 40px;
}

.butt_A {
  cursor: pointer;
  text-align: center;
  min-width: 180px;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(90deg, #6327d3, #8b4fff);
  box-shadow: 0 8px 15px rgba(99, 39, 211, 0.2);
  border-radius: 27px;
  border: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.butt_A::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}

.butt_A:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px rgba(99, 39, 211, 0.3);
}

.butt_A:hover::before {
  left: 100%;
}

.butt_B {
  cursor: pointer;
  text-align: center;
  min-width: 180px;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  color: #6327d3;
  background-color: rgba(99, 39, 211, 0.1);
  border: 2px solid transparent;
  box-shadow: 0 8px 15px rgba(99, 39, 211, 0.1);
  border-radius: 27px;
  transition: all 0.3s ease;
}

.butt_B:hover {
  background-color: rgba(99, 39, 211, 0.15);
  border-color: #6327d3;
  transform: translateY(-2px);
  box-shadow: 0 12px 20px rgba(99, 39, 211, 0.15);
}

.butt_B i {
  margin-right: 8px;
  font-size: 20px;
  vertical-align: middle;
}

.butt_c {
  cursor: pointer;
  text-align: center;
  width: 101px;
  height: 44px;
  font-size: 18px;
  color: #edf3fc;
  background: linear-gradient(90deg, #000000, #040305);
  box-shadow: 0 12px 11px 0 rgba(29, 104, 250, 0.13);
  border-radius: 36px;
  border: none;
}

.butt_c:hover {
  background: linear-gradient(90deg, #6327d3, #6327d3);
}

.butt_d {
  cursor: pointer;
  text-align: center;
  width: 101px;
  height: 44px;
  font-size: 18px;
  color: #000000;
  background-color: aliceblue;
  border: 1px solid #000000;
  box-shadow: 0 12px 11px 0 rgba(29, 104, 250, 0.13);
  border-radius: 36px;
}

.butt_d:hover {
  background: linear-gradient(90deg, #6327d3, #6327d3);
  border: 0cm;
  color: #edf3fc;
}

.main_B6_div_imgs {
  width: 82%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  /* text-align: center; */
  margin-top: 50px;
}

.main_B6_div_imgs_div {
  width: 400px;
}

.main_B6_div_imgs_div_img {
  display: flex;
  justify-content: left;
}

.main_B6_div_imgs_div_imgAB {
  display: flex;
  justify-content: center;
  transition: all 0.6s;
}

.main_B6_div_imgs_div_imgAB > img {
  width: 70px;
  height: 70px;
}

.main_B6_div_imgs_div_text {
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
}

.main_B6_div_imgs_div_textB {
  text-align: left;
}

.main_B6 {
  width: 85%;
  margin: 0 auto;
  padding-top: 200px;
  background-color: #edf3fc;
}

.main_B6_div {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.main_B6_div_H {
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.main_B6_div_text {
  /* margin-top: 100px; */
  margin-bottom: 90px;
}

.imgs_text {
  display: flex;
  justify-content: left;
}

.main_B6_div_imgs_div_textAB {
  font-size: 28px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.top_text {
  font-size: 15px;
  color: #18181b;
  margin: 0 auto;
}

.img_text {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  color: #18181b;
}

.textB6 {
  margin-left: 45px;
}

.div_8 {
  width: 70%;
  margin: 0 auto;
}

.div_8_div {
  margin-top: 140px;
}

.div_8_top_text {
  margin-bottom: 30px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  color: #9198a9;
}

.main_B6_div_imgs_div_imgAB:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_8_bot_div {
  display: flex;
  justify-content: space-between;
}

.div_8_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_8_bot_div > div {
  /* transform:translate(0,-20px); */
  transition: all 0.6s;
}

.div_9 {
  width: 70%;
  margin: 0 auto;
}

.div_9_div {
  margin-top: 140px;
}

.div_9_top_text {
  margin-bottom: 100px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_9_bot_div {
  display: flex;
  justify-content: space-between;
  margin: 0 10px 0 10px;
}

.div_10_div {
  width: 100%;
  margin: 0 auto;
}

.div_10_top_text {
  margin-top: 100px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_10_bot_div {
  width: 70%;
  display: flex;
  justify-content: center;
}

.div_9_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_9_bot_div > div {
  /* transform:translate(0,-20px); */
  transition: all 0.6s;
}

.div_9_bot_div_H1 {
  text-align: center;
  font-size: 20px;
  color: #242331;
  margin-top: 25px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
}

.div_9_bot_div_H2 {
  font-size: 16px;
  color: rgba(20, 23, 24, 0.75);
  margin-top: 20px;
  line-height: 25px;
  width: 236px;
  text-align: left;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #edf3fc;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #edf3fc;
}

.carousel_img {
  display: flex;
  justify-content: space-between;
}

.carousel_img_Htop {
  width: 540px;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #141718;
  line-height: 30px;
  text-align: left;
}

.carousel_img_Htop_lis {
  text-align: left;
  margin-top: 50px;
}

.carousel_img_Htop_li {
  font-size: 16px;
  color: #414344;
  position: relative;
  margin: 10px;
}

.carousel_img_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.bust_lo {
  margin-top: 48px;
  width: 170px;
  height: 48px;
  background: #6327d3;
  border-radius: 25px;
  font-size: 18px;
  color: #edf3fc;
  display: block;
  cursor: pointer;
  border: none;
}

.lp_top_text {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #000;
}

.div_3_overflow_y {
  /* height: 700px; */
  /* overflow-y:scroll; */
}

.div_3_overflow_div {
  height: 600px;
}

.div_3_overflow_div_div {
  margin: 0 auto;
  width: 80%;
  display: flex;
  justify-content: space-between;
}

.div_3_overflow_div_div_lef {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.div_3_overflow_div_div_lef > div {
  text-align: left;
}

.div_3_overflow_div_div_lef > div:nth-child(1) {
  font-size: 38px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  color: #141718;
  margin-top: 26px;
}

.div_3_overflow_div_div_lef > div:nth-child(2) {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  color: #141718;
  width: 86%;
  line-height: 29px;
  margin-top: 26px;
}

.div_3_overflow_div_div_lef > div:nth-child(3) {
  display: flex;
  justify-content: left;
  margin-bottom: 35px;
  margin-top: 60px;
}

.div_3_overflow_div_div_lef > div:nth-child(4) {
  display: flex;
  justify-content: left;
}

.lef_text_top {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  color: #141718;
  line-height: 21px;
}

.lef_text {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  color: #414344;
  line-height: 20px;
  margin-top: 12px;
}

.div_11_bot_div {
  width: 100%;
  max-width: 70%;
  margin: 60px auto 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 40px;
  row-gap: 78px;
}

.div_11_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_11_bot_div > div {
  transition: all 0.6s;
}

.div_12_map {
  width: 70%;
  margin: 0 auto;
  position: relative;
}

.map_li {
  width: 10px;
  height: 10px;
  background-color: #6f4287;
  border-radius: 50%;
  position: absolute;
}

.map_li:nth-child(2) {
  left: 820px;
  top: 75px;
}

.map_li:nth-child(3) {
  left: 620px;
  top: 245px;
}

.map_li:nth-child(4) {
  left: 480px;
  top: 44px;
}

.map_li:nth-child(5) {
  left: 430px;
  top: 318px;
}

.map_li:nth-child(6) {
  left: 325px;
  top: 165px;
}

.map_li:nth-child(7) {
  left: 788px;
  top: 180px;
}

.map_li:nth-child(8) {
  left: 700px;
  top: 105px;
}

.div_12 {
  width: 100%;
  border-radius: 10px;
  margin: 0 auto;
  background: radial-gradient(closest-side at 50% 50%, #6f4287 0, #34187f 100%) 0 0 no-repeat padding-box;
}

.div_12_div {
  margin-top: 50px;
}

.div_12_top_text {
  margin-bottom: 100px;
  font-size: 40px;
  color: #edf3fc;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_12_bot_div {
  display: flex;
  justify-content: space-between;
}

.mapname {
  text-align: center;
  padding: 10px 20px 10px 20px;
  color: #edf3fc;
  width: 50px;
  height: 10px;
  background-color: #0e0b3d;
  border-radius: 25px;
}

.hyzx_main_body {
  width: 70%;
  margin: 0 auto;
}

.hyzx_main_body_text {
  margin-bottom: 100px;
  margin-top: 80px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.hyzx_H {
  text-align: left;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  color: #242331;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  width: 88.91%;
  margin: 26px auto 0;
}

.hyzx_text {
  text-align: left;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(11, 10, 51, 0.57);
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
  width: 88.91%;
  margin: 21px auto 0;
}

.hyzx_but {
  display: flex;
  justify-content: right;
  padding-right: 32px;
}

.bust_hyzx {
  display: flex;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  color: #1967d2;
  align-items: center;
  justify-content: flex-end;
}

.text_div {
  width: 420px;
}

.text_div:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
  rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}

.hyzx_main_body_divs {
  display: flex;
  justify-content: space-between;
}

.pphz_main_div_H {
  font-size: 24px;
  color: #9198a9;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  margin-top: 100px;
  margin-bottom: 100px;
}

.img_pphz {
  width: 208px;
}

.gywm_but {
  display: flex;
  justify-content: left;
  flex-direction: column;
}

.gywm_but button {
  text-align: left;
  margin: 0;
}

.yycj_div {
  display: flex;
  justify-content: space-around;
}

.yycj_div button {
  margin: 0;
}

.yycj_div > div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.gywm_but_i {
  margin-right: 10px;
}
</style>

<style>
.map_li {
  width: 48px;
  height: 48px;
  display: block;
  position: relative;
  border-radius: 50%;
  background-color: #34187f;
  z-index: 1;
}

.map_li::after {
  width: 100%;
  height: 100%;
  content: "";
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  background-color: #34187f;
  animation: map_li-play 1s linear 400ms infinite;
}

.map_li::before {
  width: 100%;
  height: 100%;
  content: "";
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #34187f;
  animation: dot-play 0.5s linear 100ms infinite;
  animation-delay: 0.5s;
  /* 延迟 2s */
}

@keyframes map_li-play {
  from {
    transform: scale(1);
    opacity: 0.4;
  }

  to {
    transform: scale(4);
    opacity: 0;
  }
}
</style>

<style>
@keyframes rowup {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(0);
  }

  100% {
    -webkit-transform: translateX(0);
    transform: translateX(-50%);
  }
}

.list {
  margin: 40px auto;
  position: relative;
  overflow: hidden;
}

.list .rowup {
  -webkit-animation: 30s rowup linear infinite normal;
  animation: 30s rowup linear infinite normal;
  position: relative;
}

.rowup {
  display: flex;
  justify-content: space-between;
}

@keyframes rowupA {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(-100%);
  }

  100% {
    -webkit-transform: translateX(-50%);
    transform: translateX();
  }
}

.listA {
  position: relative;
  overflow: hidden;
}

.listA .rowupA {
  -webkit-animation: 80s rowupA linear infinite normal;
  animation: 80s rowupA linear infinite normal;
  position: relative;
}

.rowupA {
  display: flex;
  justify-content: space-between;
}
</style>
